'use client';

import { useMemo } from 'react';
import Star from 'icons/lib/star_favorite_icon.svg';
import StarHalfOutline from 'icons/lib/star_half_outline_icon.svg';
import StarOutline from 'icons/lib/star_outline_icon.svg';

import styles from './Stars.module.scss';
import { StarProps } from './types';

export const Stars = ({ score }: StarProps) => {
	const stars = useMemo(() => {
		const intPart = Math.trunc(score);
		const floatPart = Number((score - intPart).toFixed(2));

		const result: JSX.Element[] = [];

		for (let i = 0; i < 5; i++) {
			if (intPart > i) {
				/** @ts-ignore */
				result.push(<Star fill="#f7b526" key={i} />);
				continue;
			}

			if (intPart === i) {
				if (floatPart >= 0.6) {
					/** @ts-ignore */
					result.push(<Star fill="#f7b526" key={i} />);
					continue;
				}

				if (floatPart >= 0.1) {
					/** @ts-ignore */
					result.push(<StarHalfOutline fill="#f7b526" key={i} />);
					continue;
				}

				/** @ts-ignore */
				result.push(<StarOutline key={i} />);
				continue;
			}

			result.push(<StarOutline key={i} />);
		}

		return result;
	}, [score]);

	return <div className={styles.stars}>{stars}</div>;
};
